import styled from "styled-components";

export const ToolbarDivider = styled.div`
  width: 0.5px;
  height: 24px;
  background-color: ${({ theme }) => theme.colorTextDescription};
`;
